import { render } from "./Error.vue?vue&type=template&id=1463b126&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=1463b126&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1463b126"

export default script